import React, { useEffect, useState } from "react";
import { fetchStreamInfo } from "../lib/api";
import { LiveBar } from "../components/LiveBar";
import { Hero } from "../components/Hero";
import { StreamSection } from "../components/StreamSection";
import { ChatSection } from "../components/ChatSection";
import { ScheduleBanner } from "../components/ScheduleBanner";
import { SocialsSection } from "../components/SocialsSection";
import { AskQuestion } from "../components/AskQuestion";
import { AboutSection } from "../components/AboutSection";
import { ClipsSection } from "../components/ClipsSection";
import { LedgerSection } from "../components/LedgerSection";
import { QASection } from "../components/QASection";
import { SupportSection } from "../components/SupportSection";
import { FloatingTip } from "../components/FloatingTip";
import { Footer } from "../components/Footer";

export default function Home() {
    const [streamInfo, setStreamInfo] = useState(null);

    useEffect(() => {
        fetchStreamInfo()
            .then(setStreamInfo)
            .catch(() => setStreamInfo(null));
    }, []);

    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <div data-testid="home-page" className="min-h-screen">
            <LiveBar onWatch={() => scrollTo("stream")} />
            <Hero onWatch={() => scrollTo("stream")} onAsk={() => scrollTo("ask")} />
            <ScheduleBanner />
            <AboutSection />
            <ClipsSection />
            <StreamSection streamInfo={streamInfo} />
            <ChatSection streamInfo={streamInfo} />
            <QASection />
            <LedgerSection />
            <SocialsSection />
            <SupportSection />
            <AskQuestion />
            <Footer />
            <FloatingTip />
        </div>
    );
}
